import { Button, Message, Radio } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/home-configurations.module.scss";
import { TimeInput } from "shared/components/TimeInput";
import { Icon } from "shared/components/core/Icon";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const days = [
  {
    key: 0,
    short: "D",
    full: "domingo",
  },
  {
    key: 1,
    short: "S",
    full: "segunda-feira",
  },
  {
    key: 2,
    short: "T",
    full: "terça-feira",
  },
  {
    key: 3,
    short: "Q",
    full: "quarta-feira",
  },
  {
    key: 4,
    short: "Q",
    full: "quinta-feira",
  },
  {
    key: 5,
    short: "S",
    full: "sexta-feira",
  },
  {
    key: 6,
    short: "S",
    full: "sábado",
  },
];

const Availability = ({ availability, onChange, item, onConflicts }) => {
  const [visibility, setVisibility] = useState(availability || null);

  useEffect(() => {
    if (visibility) {
      const removeColons = (array) => {
        return array.map((item) => ({
          ...item,
          start: item.start.replace(/:/g, ""),
          end: item.end.replace(/:/g, ""),
        }));
      };

      const updatedVisibility = visibility.map((weekDay) => ({
        ...weekDay,
        times: removeColons(weekDay.times),
      }));

      onChange(updatedVisibility);

      return;
    }

    onChange(null);
  }, [visibility]);

  const isSelectedDay = (day) => {
    return (visibility || [])?.some((d) => d.weekDay === day);
  };

  const selectDaysWeek = (day) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find((obj) => obj.weekDay === day);

      if (targetObject) {
        updatedVisibility.splice(updatedVisibility.indexOf(targetObject), 1);
      } else {
        const weekDay = {
          type: "week_day",
          weekDay: day,
          times: [
            {
              start: "00:00",
              end: "12:00",
            },
          ],
        };
        updatedVisibility.push(weekDay);
        updatedVisibility.sort((a, b) => a.weekDay - b.weekDay);
      }

      return updatedVisibility;
    });
  };

  const addOrRemoveTime = (weekDay, newTime, indexToRemove) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find(
        (obj) => obj.weekDay === weekDay
      );

      if (indexToRemove !== undefined && indexToRemove >= 0) {
        targetObject.times.splice(indexToRemove, 1);
      } else {
        if (targetObject) {
          targetObject.times.push(newTime);
        } else {
          const newObject = {
            type: "week_day",
            weekDay,
            times: [newTime],
          };
          updatedVisibility.push(newObject);
        }
      }

      return updatedVisibility;
    });
  };

  const changeTime = (weekDay, timeIndex, field, value) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find(
        (obj) => obj.weekDay === weekDay
      );

      if (targetObject) {
        targetObject.times[timeIndex][field] = value;
      }

      return updatedVisibility;
    });
  };

  const checkTimeErrors = (weekDay) => {
    const conflicts = [];

    const targetObject = visibility.find((obj) => obj.weekDay === weekDay);

    if (targetObject?.times) {
      for (let i = 0; i < targetObject.times.length; i++) {
        if (
          targetObject.times[i].start === targetObject.times[i].end ||
          targetObject.times[i].start >= targetObject.times[i].end
        ) {
          conflicts.push({
            weekDay: weekDay,
            conflictingTime: targetObject.times[i],
          });
        }
      }
    }

    return conflicts.length > 0;
  };

  return (
    <div className={styles.configContainer}>
      <p className={styles.title}>
        Disponibilidade {item ? "deste item" : "desta seção"}
      </p>
      <div className={styles.hairline} />
      <Radio
        family="availability"
        className="mb-10"
        value={true}
        checked={visibility === null}
        onChange={() => setVisibility(null)}
      >
        A todo momento
      </Radio>
      <Radio
        family="availability"
        value={true}
        checked={!!visibility}
        onChange={() => setVisibility([])}
      >
        Em momentos específicos
      </Radio>

      {!!visibility && (
        <>
          <div className={styles.days}>
            {days.map((day) => (
              <div
                className={css({
                  day: true,
                  isSelected: isSelectedDay(day.key),
                })}
                onClick={() => selectDaysWeek(day.key)}
                key={day.full}
              >
                {day.short}
              </div>
            ))}
          </div>

          {visibility.map((v) => {
            const isIncluded = days.some((day) => day.key === v.weekDay);

            if (!isIncluded) return null;

            return (
              <div className={styles.times} key={v.weekDay}>
                <div className={styles.label}>
                  Horário <strong>{days[v.weekDay].full}:</strong>
                </div>
                {v.times.map((time, timeIndex) => {
                  const hourStart = time.start.substring(0, 2);
                  const minutesStart = time.start.substring(
                    time.start.length - 2
                  );
                  const hourEnd = time.end.substring(0, 2);
                  const minutesEnd = time.end.substring(time.end.length - 2);

                  const startTime = `${hourStart}:${minutesStart}`;
                  const endTime = `${hourEnd}:${minutesEnd}`;

                  return (
                    <div className="d-flex align-stretch mt-25" key={timeIndex}>
                      <TimeInput
                        value={startTime}
                        onChange={(value) =>
                          changeTime(v.weekDay, timeIndex, "start", value)
                        }
                        label="De"
                        className="pt-0 mb-0 mr-15 w-100"
                      />
                      <TimeInput
                        value={endTime}
                        onChange={(value) =>
                          changeTime(v.weekDay, timeIndex, "end", value)
                        }
                        label="Até"
                        className="pt-0 mb-0 mr-15 w-100"
                      />
                      <Button
                        className="mr-15"
                        onClick={() =>
                          addOrRemoveTime(v.weekDay, {
                            start: "00:00",
                            end: "12:00",
                          })
                        }
                      >
                        <Icon name="plus" />
                      </Button>
                      <Button
                        onClick={() =>
                          addOrRemoveTime(v.weekDay, null, timeIndex)
                        }
                        disabled={v.times.length === 1}
                      >
                        <Icon name="trash" />
                      </Button>
                    </div>
                  );
                })}

                {checkTimeErrors(v.weekDay) && (
                  <Message type="danger" className="mt-20">
                    Verifique os horários
                  </Message>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Availability;
